import {
  SetIsUserLiveAction,
  SetIsUserLiveFromThisSessionAction,
} from "../liveActions/liveActions";
import { getUser } from "../../../services/authService";
import { checkFcmToken } from "../../../services/notificationService";
import { fetchFlaggingKeywords } from "../../../services/cmsService";

export const POST_CATEGORY = "POST_CATEGORY";
export const USER = "USER";
export const FROM = "FROM";
export const ALL_CLEAR = "ALL_CLEAR";
export const FLAGGED_KEYWORDS = "FLAGGED_KEYWORDS";
export const IS_MODERATOR = "IS_MODERATOR";
export const MODERATOR_PERMISSIONS = "MODERATOR_PERMISSIONS";
export const IS_FCM_TOKEN_AVAILABLE = "IS_FCM_TOKEN_AVAILABLE";

export const UserAction = (dispatch) => {
  return async () => {
    try {
      const response = await getUser();
      if (response?.data?.user) {
        const user = response.data.user;
        dispatch(SetUserAction(user));
        //if (!!user.egress_id && !!user.room_token && !!user.auth_token) {
          if (!!user.mux_live_stream_id && !!user.call_id && !!user.auth_token) {
          dispatch(SetIsUserLiveAction(true));
          if (user.auth_token === window.localStorage.getItem("token")) {
            dispatch(SetIsUserLiveFromThisSessionAction(true));
          } else {
            dispatch(SetIsUserLiveFromThisSessionAction(false));
          }
        } else {
          dispatch(SetIsUserLiveAction(false));
        }
      }
    } catch (err) {
      console.log(err);
    }
  };
};

export const FlaggingKeywordsAction = (dispatch) => {
  return async () => {
    try {
      const response = await fetchFlaggingKeywords();
      if (response.data.statusCode === 200) {
        const keywords = response.data?.keyword?.map((keyword) =>
          keyword.flagging_keyword.toLowerCase()
        );
        dispatch(SetFlaggingKeywordsAction(keywords));
      }
    } catch (err) {
      console.log(err);
    }
  };
};

export const FetchFcmStatusAction = (dispatch) => {
  return async () => {
    try {
      const response = await checkFcmToken();
      if (response.status === 200) {
        dispatch(SetFcmTokenStatusAction(response.data.fcm_token_exists));
      }
    } catch (err) {
      console.log(err);
    }
  };
};

export const SetUserAction = (value) => {
  return { type: USER, value };
};

export const SetFcmTokenStatusAction = (value) => {
  return { type: IS_FCM_TOKEN_AVAILABLE, value };
};

export const SetFlaggingKeywordsAction = (value) => {
  return { type: FLAGGED_KEYWORDS, value };
};